import { render, staticRenderFns } from "./ModelLoadProgress.vue?vue&type=template&id=72522215&scoped=true"
import script from "./ModelLoadProgress.vue?vue&type=script&lang=js"
export * from "./ModelLoadProgress.vue?vue&type=script&lang=js"
import style0 from "./ModelLoadProgress.vue?vue&type=style&index=0&id=72522215&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72522215",
  null
  
)

export default component.exports